module.exports = __webpack_public_path__ + "static/media/3.296a151d.svg";